import { cva } from 'class-variance-authority';
import styles from '../presentation/styles.module.scss';

export const badgeVariants = cva(styles.badge, {
  variants: {
    status: {
      neutral: styles.neutral,
      info: styles.info,
      success: styles.success,
      warning: styles.warning,
      negative: styles.negative,
    },
    variant: {
      outline: styles.outline,
      solid: styles.solid,
      subtle: styles.subtle,
    },
    size: {
      sm: styles.sm,
      md: styles.md,
      lg: styles.lg,
    },
  },
  defaultVariants: {
    status: 'neutral',
    variant: 'solid',
    size: 'md',
  },
});

export const closeButtonVariants = cva(styles.closeButton, {
  variants: {
    status: {
      neutral: '',
      info: '',
      success: '',
      warning: '',
      negative: '',
    },
    variant: {
      outline: '',
      solid: '',
      subtle: '',
    },
    size: {
      sm: styles.closeButtonSm,
      md: styles.closeButtonMd,
      lg: styles.closeButtonLg,
    },
  },
  defaultVariants: {
    status: 'neutral',
    variant: 'solid',
    size: 'md',
  },
});
